/**
 * CLE-2812 — the Effective Totals shown on the AI Insights tab, in dollars.
 *
 * They come from the claim's own expected / allowed (cents), the same columns the claim header and
 * the Expected Amounts tab read, so the three can never disagree. A stored analysis carries its own
 * copy of these totals, but that copy is a snapshot: analyses written before CLE-2812 hold
 * model-computed figures, and any analysis goes stale when the claim's expected later moves without
 * the analysis being regenerated (a new remit event, a late 837 match). The stored copy is only the
 * fallback for a claim that has no amounts to read.
 */
export interface IEffectiveTotalsView {
  effectiveExpectedAllowed: number;
  effectiveActualAllowed: number;
  underpaymentAmount: number;
}

export function resolveEffectiveTotals(
  stored: IEffectiveTotalsView,
  expectedAmountInCents: number | null | undefined,
  claimAmountInCents: number | null | undefined
): IEffectiveTotalsView {
  if (expectedAmountInCents == null || claimAmountInCents == null) {
    return stored;
  }
  return {
    effectiveExpectedAllowed: expectedAmountInCents / 100,
    effectiveActualAllowed: claimAmountInCents / 100,
    underpaymentAmount: (expectedAmountInCents - claimAmountInCents) / 100,
  };
}
